import React from 'react';
import { TextInput } from '../../Form';

export default function QuantityField({
  id,
  name,
  value,
  onChange,
  required = false,
  min = 0,
  max = 9999,
}) {
  return (
    <TextInput
      id={id}
      name={name}
      type="number"
      min={min}
      max={max}
      value={value}
      onChange={e => {
        // convert to number before passing to onChange
        const value = parseInt(e.target.value, 10);

        if (isNaN(value)) {
          onChange('');
          return;
        }

        onChange(value);
      }}
      required={required}
      className="mx-1 !w-auto text-center cp_form-textinput !py-1.5 !w-12"
    />
  );
}
